import React, { useState } from "react";
import { NavLink } from 'react-router-dom'
import "../css/signup.css"
import "../css/login.css"
import { useNavigate } from "react-router-dom";
import "../css/loading.css"
import RingLoader from "react-spinners/RingLoader"


// import { useNavigate } from 'react-router-dom';
// import axios from 'axios'
// import { set } from "mongoose";

const Signup = () => {

  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    firstname: "",
    name: "",
    email: "",
    password: "",
    cpassword: "",
  });

  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [message, setMessage] = useState("");
  const [user, setUser] = useState({})
  const [busy, setBusy] = useState(false)

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      setBusy(true)
      const response = await fetch("https://petme.onrender.com/register", {

        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      setBusy(false)

      const data = await response.json();
      setUser(data)
      if (response.ok) {
        setOtpSent(true);
        setMessage("Otp sent to the email id");
      } else {
        setMessage(data.error);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleVerifyOtp = async (e) => {
    setBusy(true)
    e.preventDefault();
    try {
      const response = await fetch("https://petme.onrender.com/verify-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userId: user.user.id,
          otp: otp,
        }),
      });
      setBusy(false)

      const data = await response.json();
      if (response.ok) {
        setMessage(data.message);
        setTimeout(() => {
        navigate("/login")
        }, 3000);
      } else {
        setMessage(data.error);
      }
    } catch (error) {
      console.log(error);
    }
  };

  if (otpSent) {
    return (
      <div className="signup-otpDiv">
        <h2 className="signup-otpHeading">Verify OTP</h2>
        <form className="signup-otpForm" onSubmit={handleVerifyOtp}>
          <input
            className="signup-otpInput"
            type="text"
            name="otp"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
          />
          <button className="signup-otpSubmitBtn" type="submit">Verify OTP</button>
        </form>
        {message && <p>{message}</p>}
      </div>
    );
  }

  if(busy){
    return(
      <div className="loader-container" >
    <RingLoader color="#36d7b7" loading size={90} />
    <h1 className="loading-heading">Verifying details.Please wait...</h1>
  </div>
    )
  }

  return (

    <div>
      <div class="signup-bg_img"></div>
      <div class="signup-div">
        <div class="signup-background-content">
          <h1 class="signup new-acount">Create New Account</h1>
          <form action="" class="form signup-form">
            <input id="first-name" type="name" name="firstname" class="signup-box" value={formData.firstname} onChange={handleChange} placeholder="first name" /><br />
            <input id="second-name" type="name" name="name" class="signup-box" value={formData.name} onChange={handleChange} placeholder="last name" /><br />
            <input id="email" type="email" name="email" class="signup-box" value={formData.email} onChange={handleChange} placeholder="email address" /><br />
            <input id="password" type="password" name="password" class="signup-box" value={formData.password} onChange={handleChange} placeholder="password" /><br />
            <input id="cpassword" type="password" name="cpassword" class="signup-box" value={formData.cpassword} onChange={handleChange} placeholder="confirm password" /><br />
            <NavLink id="submit-signup" className="submit-signup-btn" onClick={handleRegister}>CREATE ACCOUNT</NavLink>
          </form>
          {message && <p>{message}</p>}
          <p class="already-account">Already have an account? <NavLink className="signup-navlink" to="/login"><span className="login-link" >Login</span></NavLink></p>
        </div>
      </div>
    </div>
  );




};


export default Signup